import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get, pick } from 'lodash/fp';
import request from 'utils/request_ajax';
import { routes as ROUTES } from 'constants/config';
import { Icon } from 'ui';
import openPopup from 'utils/open_popup';
import { pluralize } from 'utils/string_utils';
import addModifiers from 'utils/add_modifiers';
import AlertBox, { Heading, SubHeading } from 'components/shared/AlertBox';

class ConfirmationModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { customMessage: '', assignNewContent: false };
    this.handlePreviewEmail = this.handlePreviewEmail.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handlePreviewEmail() {
    openPopup({ name: 'email_preview' }).then(popup => {
      const previewRoute = ROUTES.ASSIGNMENT_ADDED_CONTENTS_PREVIEW(
        this.props.pathId,
      );
      const data = {
        contents: this.props.contents.map(pick(['id', 'type'])),
        message: this.state.customMessage,
      };
      request.postJSON(previewRoute, data, { dataType: 'html' }).then(html => {
        const css = popup.document.createElement('style');
        css.innerHTML =
          "body { padding: 5%; background: rgb(244, 244, 244); font: normal 13px/1 'proxima-nova', 'Helvetica Neue', sans-serif;} .maincontain { box-shadow: 0px 1px 1px 0px #ececec; }";
        popup.document.body.innerHTML = html;
        popup.document.body.appendChild(css);
      });
    });
  }

  handleSubmit() {
    this.props.onSubmit(this.state);
  }

  handleInputChange({ target }) {
    const { value, type, name } = target;
    const isRadioButton = type.match('radio');
    this.setState({
      [name]: isRadioButton ? JSON.parse(value) : value,
    });
  }

  render() {
    const { onCancel, updateInProgress, completedCount, isCertification } =
      this.props;
    const { assignNewContent, customMessage } = this.state;

    const LearnersCount = (
      <b className="c-brand-gray-darkest">
        {`${completedCount} ${pluralize(completedCount, 'learner')}`}
      </b>
    );

    return (
      <AlertBox onDismiss={onCancel}>
        <Heading>
          {isCertification
            ? t('certifications.update_confirmation_modal.title')
            : 'You’re adding content to this Path'}
        </Heading>
        <SubHeading>
          How should this affect the {LearnersCount} who{' '}
          {pluralize(completedCount, 'has', 'have')} previously completed this{' '}
          {isCertification ? 'Certification Path' : 'Path'}?
        </SubHeading>
        <div className="FormGroup mt-24">
          <label htmlFor="assignNewContent-false" className="mb-8">
            <input
              type="radio"
              id="assignNewContent-false"
              name="assignNewContent"
              value={false}
              checked={assignNewContent === false}
              onChange={this.handleInputChange}
            />
            <span className="ml-8">
              Do not require the new content, but make it visible to them
            </span>
          </label>
          <label htmlFor="assignNewContent-true">
            <input
              type="radio"
              id="assignNewContent-true"
              name="assignNewContent"
              value={true}
              checked={assignNewContent === true}
              onChange={this.handleInputChange}
            />
            <span className="ml-8">Require the new content to be complete</span>
          </label>
          {assignNewContent && (
            <div className="FormGroup-subset mt-16">
              <div className="mb-8 fz-base d-f jc-sb">
                <label htmlFor="customMessage" className="c-brand-gray-darker">
                  Custom Assignment Email Message (optional)
                </label>
                <button
                  type="button"
                  className="AssignModal-previewEmailBtn"
                  onClick={this.handlePreviewEmail}
                  disabled={!customMessage.trim().length}
                >
                  Preview Email
                  <Icon name="external-link" />
                </button>
              </div>
              <textarea
                id="customMessage"
                name="customMessage"
                value={customMessage}
                onChange={this.handleInputChange}
                className="Textarea PathUpdateModal-emailMessageInput"
                ref={n => n && n.focus()}
              />
            </div>
          )}
        </div>
        <div className="d-f jc-e ai-c mt-24">
          <button
            type="button"
            className="u-linkBtn u-linkBtn--dark td-u"
            onClick={onCancel}
            children="Cancel"
          />
          <button
            type="button"
            className={`ml-16 ${addModifiers('NewButton', [
              'yellow',
              'tallAndWide',
            ])}`}
            onClick={this.handleSubmit}
          >
            {updateInProgress && <span className="Spinner mr-8" />}
            Update Path
          </button>
        </div>
      </AlertBox>
    );
  }
}

const mapStateToProps = state => ({
  pathId: state.pathBuilder.id,
  contents: state.pathBuilder.contents,
  isCertification: !!get('certification')(state.pathBuilder),
});

export default connect(mapStateToProps)(ConfirmationModal);
